import {
  GET_MOORINGLINE_DETAILS,
  SHOW_MOORINGLINE_LOADING,
  MOORINGLINE_ERROR,
  DELETE_MOORINGLINE_RECORD,
  DELETE_MOORINGTOWING_RECORD,
} from '../actions/types';

/**
 * maco-magsael-sc-1000: Logbook - add mooring log in list of logbooks
 */

const initialState = {
  mooringlinelist: [],
  mooringlineID: null,
  mooringlineDetails: null,
  mooringlineLoading: false,
  editMooringlineLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MOORINGLINE_LOADING:
      return {
        ...state,
        mooringlineLoading: true,
      };
    case GET_MOORINGLINE_DETAILS:
      return {
        ...state,
        mooringlineDetails: payload,
        mooringlineLoading: false,
        editMooringlineLoading: false,
      };
    case MOORINGLINE_ERROR:
      return {
        ...state,
        error: payload,
        mooringlineLoading: false,
      };
    case DELETE_MOORINGLINE_RECORD:
      return {
        ...state,
        mooringlineDetails: payload,
        mooringlineLoading: false,
        editMooringlineLoading: false,
      };
    case DELETE_MOORINGTOWING_RECORD:
      return {
        ...state,
        mooringlineDetails: payload,
        mooringlineLoading: false,
        editMooringlineLoading: false,
      };
    default:
      return state;
  }
}
